import { PLBTypes } from "enums";

export const accountListFilterState = (searchKey) => ({
  startDate: null,
  endDate: null,
  searchKey: searchKey || "",
  accountType: "all",
  plbType: {
    value: [PLBTypes.PLB_HEDGING, PLBTypes.PLB_LOCQPAY, PLBTypes.PLB_LOCQPAY_MANUAL_PO, PLBTypes.PLB_LOCQPAY_MANUAL_PO_CREDIT],
    isSelectedAll: true,
  },
  status: "all",
  page: 1,
  perPage: 10,
});
